/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RequestType {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
}
